export default Object.freeze({
    ADMINISTRATOR: {
        ID: 7,
        NAME: 'Administrator',
    },
    CLERK: {
        ID: 6,
        NAME: 'Clerk',
    },
    MEDICAL_ASSISTANT: {
        ID: 3,
        NAME: 'Medical Assistant / CNA',
    },
    NURSE: {
        ID: 4,
        NAME: 'Nurse',
    },
    OFFICE_MANAGER: {
        ID: 5,
        NAME: 'Office Manager / Administrator',
    },
    PHYSICIAN: {
        ID: 1,
        NAME: 'Physician',
    },
    NURSE_PRACTITIONER: {
        ID: 8,
        NAME: 'Physician Assistant / Nurse Practitioner',
    },
    TEMPORARY_PHYSICIAN: {
        ID: 10,
        NAME: 'Temporary Physician',
    },
})
